<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <el-tabs v-model="activeTab"
                       type="border-card"
                       @tab-click="tabsChange">
                <el-tab-pane label="手术项目"
                             name="1">
                  <el-card style="margin-bottom: 15px">
                    <el-input v-model="search1.user_name"
                              size="small"
                              style="width: 200px"
                              placeholder="申请人"></el-input>
                    <el-select v-model="search1.project_apply_id"
                               placeholder="请选择项目"
                               style="width: 400px"
                               size="small"
                               clearable>
                      <el-option v-for="(item, index) in projectList1"
                                 :key="index"
                                 :label="item.project_name"
                                 :value="item.project_apply_id">
                        <span style="float: left">{{ item.project_name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.project_apply_time }}</span>
                      </el-option>
                    </el-select>

                    <el-select v-model="search1[status_info1.param]"
                               placeholder="状态"
                               style="width: 200px"
                               size="small"
                               clearable>
                      <el-option el-option
                                 :label="item.value"
                                 :value="item.key"
                                 v-for="(item, index) in status_info1.values"
                                 :key="index"></el-option>
                    </el-select>

                    <el-button type="primary"
                               size="small"
                               icon="el-icon-search"
                               @click="$refs['tables1'].handleSearch()">搜索</el-button>
                  </el-card>

                  <WtDataTable ref="tables1"
                               :search="search1"
                               v-if="activeTab === '1'"
                               :urlParams="{if_pay:3}"
                               key="tables1"
                               :listUrl="$db.config.cf_project.apply.list">
                    <div slot="buttons">
                      <el-button type="primary"
                                 size="small"
                                 icon="el-icon-download"
                                 style="float: right; margin-bottom: 10px"
                                 :loading="export_loading"
                                 @click="doExport">{{
                          export_loading ? "导出中……" : "导出手术项目费用组成单"
                        }}</el-button>
                    </div>
                    <template slot="columns">
                      <el-table-column label="序号"
                                       prop="key"
                                       min-width="65"
                                       align="center">
                        <template slot-scope="scope">{{
                          scope.row.key
                        }}</template>
                      </el-table-column>
                      <el-table-column label="申请人"
                                       align="center"
                                       min-width="150"
                                       prop="user_name">
                        <template slot-scope="scope">
                          <a href="JavaScript:;"
                             @click="goDetail3(scope.row)">{{ scope.row.user_name }}</a>
                        </template>
                      </el-table-column>

                      <el-table-column label="项目名称"
                                       prop="project_name"
                                       min-width="300">
                        <template slot-scope="scope">
                          <a href="JavaScript:;"
                             @click="goDetail1(scope.row)">{{ scope.row.project_name }}</a>
                          <p>
                            项目申请时间：{{ scope.row.project_apply_time }}
                          </p>
                        </template>
                      </el-table-column>

                      <el-table-column label="申请时间"
                                       prop="regtime"
                                       align="center"
                                       min-width="100"></el-table-column>

                      <el-table-column label="申请金额"
                                       prop="surplus_money"
                                       align="center"
                                       min-width="100">
                        <template slot-scope="scope">
                          {{ scope.row.surplus_money | setNumFormat }}
                        </template>
                      </el-table-column>

                      <el-table-column label="拨款状态"
                                       prop="status_text"
                                       align="center"
                                       min-width="100">
                        <template slot-scope="scope">
                          <span style="
                              color: red;
                              text-decoration: underline;
                              cursor: pointer;
                            "
                                v-if="scope.row.status == 2">
                            <el-popover placement="top"
                                        title="审核意见："
                                        width="200"
                                        trigger="click"
                                        :content="scope.row.status_audit_opinion">
                              <span slot="reference">{{
                                scope.row.status_text
                              }}</span>
                            </el-popover>
                          </span>
                          <span v-else>{{
                            scope.row.status_text
                              ? scope.row.status_text
                              : "未申请拨款"
                          }}</span>
                        </template>
                      </el-table-column>

                      <el-table-column label="操作"
                                       min-width="250"
                                       align="center"
                                       fixed="right">
                        <template slot-scope="scope">
                          <el-button-group>
                            <el-button type="primary"
                                       icon="el-icon-edit"
                                       size="mini"
                                       v-if="
                                !(
                                  scope.row.status == 1 || scope.row.status == 3
                                )
                              "
                                       @click="doPayment1(scope.row)">{{
                                scope.row.pay_id > 0 ? "编辑拨款" : "申请拨款"
                              }}</el-button>
                            <el-button type="primary"
                                       icon="el-icon-view"
                                       size="mini"
                                       v-if="scope.row.pay_id > 0"
                                       @click="goDetail(scope.row, 1)">拨款信息</el-button>
                            <el-button type="primary"
                                       icon="el-icon-edit"
                                       size="mini"
                                       v-if="scope.row.is_media"
                                       @click="doMedia(scope.row)">媒体报道</el-button>
                            <el-button type="primary"
                                       icon="el-icon-edit"
                                       size="mini"
                                       v-if="scope.row.is_media"
                                       @click="doVisit(scope.row)">回访记录</el-button>
                          </el-button-group>
                        </template>
                      </el-table-column>
                    </template>
                  </WtDataTable>
                </el-tab-pane>
                <el-tab-pane label="非手术项目"
                             name="2">
                  <el-card style="margin-bottom: 15px">
                    <el-select v-model="search2.project_apply_id"
                               placeholder="请选择项目"
                               style="width: 400px"
                               size="small"
                               clearable>
                      <el-option v-for="(item, index) in projectList2"
                                 :key="index"
                                 :label="item.project_name"
                                 :value="item.project_apply_id">
                        <span style="float: left">{{ item.project_name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.project_apply_time }}</span>
                      </el-option>
                    </el-select>

                    <el-select v-model="search2[status_info2.param]"
                               placeholder="状态"
                               style="width: 200px"
                               size="small"
                               clearable>
                      <el-option el-option
                                 :label="item.value"
                                 :value="item.key"
                                 v-for="(item, index) in status_info2.values"
                                 :key="index"></el-option>
                    </el-select>

                    <el-button type="primary"
                               size="small"
                               icon="el-icon-search"
                               @click="$refs['tables2'].handleSearch()">搜索</el-button>
                  </el-card>
                  <WtDataTable ref="tables2"
                               :search="search2"
                               v-if="activeTab === '2'"
                               key="tables2"
                               :listUrl="$db.config.getCfProjectAppropriation">
                    <div slot="buttons">
                      <el-button size="small"
                                 style="margin: 0px 0px 10px"
                                 type="primary"
                                 @click="doPayment2"
                                 icon="el-icon-plus">申请</el-button>

                      <el-button type="primary"
                                 size="small"
                                 icon="el-icon-download"
                                 style="float: right"
                                 :loading="export_loading"
                                 @click="doExport">{{
                          export_loading
                            ? "导出中……"
                            : "导出非手术项目费用组成单"
                        }}</el-button>
                    </div>
                    <template slot="columns">
                      <el-table-column label="序号"
                                       prop="key"
                                       min-width="65"
                                       align="center">
                        <template slot-scope="scope">{{
                          scope.row.key
                        }}</template>
                      </el-table-column>
                      <el-table-column label="项目名称"
                                       prop="project_name"
                                       min-width="300">
                        <template slot-scope="scope">
                          <a href="JavaScript:;"
                             @click="goDetail2(scope.row)">{{ scope.row.project_name }}</a>
                        </template>
                      </el-table-column>
                      <el-table-column label="拨款申请时间"
                                       prop="reg_time"
                                       align="center"
                                       width="150">
                      </el-table-column>
                      <el-table-column label="申请金额"
                                       prop="apply_money"
                                       align="center"
                                       min-width="100">
                        <template slot-scope="scope">
                          {{ scope.row.apply_money | setNumFormat }}
                        </template>
                      </el-table-column>

                      <!-- <el-table-column
                        label="总分配金额"
                        prop="top_money"
                        align="center"
                        min-width="150"
                      ></el-table-column> -->
                      <el-table-column label="状态"
                                       prop="status_text"
                                       align="center"
                                       min-width="100">
                        <template slot-scope="scope">
                          <span style="
                              color: red;
                              text-decoration: underline;
                              cursor: pointer;
                            "
                                v-if="
                              scope.row.audit_opinion && scope.row.status == 2
                            ">
                            <el-popover placement="top"
                                        title="审核意见："
                                        width="200"
                                        trigger="click"
                                        :content="scope.row.audit_opinion">
                              <span slot="reference">{{
                                scope.row.status_text
                              }}</span>
                            </el-popover>
                          </span>
                          <span v-else>{{ scope.row.status_text }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作"
                                       width="250"
                                       align="center"
                                       fixed="right">
                        <template slot-scope="scope">
                          <el-button-group>
                            <el-button type="primary"
                                       icon="el-icon-edit"
                                       v-if="scope.row.if_option"
                                       size="mini"
                                       @click="doPayment2(scope.row)">编辑拨款</el-button>
                            <el-button type="primary"
                                       icon="el-icon-view"
                                       size="mini"
                                       v-else
                                       @click="goDetail(scope.row, 2)">拨款信息</el-button>
                          </el-button-group>
                        </template>
                      </el-table-column>
                    </template>
                  </WtDataTable>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>
        </el-row>
      </div>

      <detail v-if="if_open4"
              v-model="if_open4"
              :pid="project_id"
              :id="pay_id"
              :title="detail_title"
              :type="project_type"></detail>

      <pro-detail v-if="if_open"
                  v-model="if_open"
                  :pid="project_id"
                  :aid="project_apply_id"></pro-detail>
      <user-detail v-if="if_open3"
                   v-model="if_open3"
                   :pid="project_id"
                   :id="apply_id"></user-detail>
      <info1 v-if="if_open1"
             v-model="if_open1"
             :id="apply_id"
             :aid="project_apply_id"
             :pid="project_id"
             :pay_id="pay_id"
             :title="info_title1"
             @success="success"></info1>
      <info2 v-if="if_open2"
             v-model="if_open2"
             :id="apply_id"
             :title="info_title2"
             @success="success"></info2>

      <media v-if="media_show"
             v-model="media_show"
             :title="media_title"
             :aid="apply_id"
             :id="project_id"
             :type="2"></media>

      <visit v-if="visit_show"
             v-model="visit_show"
             :title="visit_title"
             :id="apply_id"></visit>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import detail from "./detail";
import proDetail from "../info/detail";
import userDetail from "../apply/detail";
import info1 from "./info1";
import info2 from "./info2";
import media from "../info/media";
import visit from "./visit_list";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    detail, //拨款详情
    proDetail, //项目详情
    userDetail, //申请人详情
    info1, //手术项目
    info2, //非手术项目
    visit, //提交回访记录
    media, // 提交媒体报道
  },
  data () {
    return {
      activeTab: "1", // 1表示手术项目  2非手术
      search1: { project_type: 1 },
      search2: { project_type: 2 },

      status_info1: { param: null, values: [] }, //筛选状态
      status_info2: { param: null, values: [] }, //筛选状态
      apply_id: null,
      media_title: null,
      media_show: false,
      visit_title: {},
      visit_show: false,

      export_loading: false,

      projectList1: [],
      projectList2: [],

      project_id: null,

      project_apply_id: null,

      project_type: null, //1手术项目  2非手术项目

      if_open3: false, //申请人详情

      if_open: false, //项目详情
      if_open1: false, //手术项目

      info_title1: {
        project_name: null,
        user_name: null,
      },

      if_open2: false, //非手术项目
      info_title2: "",

      if_open4: false, //拨款信息详情
      pay_id: null, //判断手术项目 是否编辑拨款申请
      detail_title: {
        user_name: null,
        pro_name: null,
      },
    };
  },
  mounted () {
    this.getProjectList1();
    this.getProjectList2();
    this.getStatusInfo1();
    this.getStatusInfo2();
  },
  methods: {
    tabsChange (val) {
      this.search1 = {};
      this.search2 = {};
    },

    //获取筛选下拉选择
    getStatusInfo1 () {
      this.$db
        .post(this.$db.config.cf_project.info.status_info, {
          name: "CROWD_OPERATION_PAYMENT_AUDIT",
        })
        .then((res) => {
          this.status_info1 = res.data;
        });
    },

    //获取筛选下拉选择
    getStatusInfo2 () {
      this.$db
        .post(this.$db.config.cf_project.info.status_info, {
          name: "CROWD_NON_OPERATION_PAYMENT_AUDIT",
        })
        .then((res) => {
          this.status_info2 = res.data;
        });
    },

    //操作媒体报道
    doMedia (row) {
      this.project_id = row.project_id;
      this.apply_id = row.id;
      this.media_title = row.user_name;
      this.media_show = true;
    },

    //提交走访记录
    doVisit (row) {
      this.apply_id = row.id;
      this.visit_title.project_name = row.project_name;
      this.visit_title.user_name = row.user_name;
      this.visit_show = true;
    },

    //导出导出费用组成单
    doExport () {
      let url;
      let params;
      if (this.activeTab == 1) {
        url = this.$db.config.cf_project.payout.export1;
        params = this.search1;
      } else {
        url = this.$db.config.cf_project.payout.export2;
        params = this.search2;
      }
      this.export_loading = true;
      this.$db.downFilePost(url, params).then((res) => {
        if (res.hasOwnProperty("code")) {
          var enc = new TextDecoder("utf-8");
          var result = JSON.parse(enc.decode(new Uint8Array(res)));
        } else {
          this.download(res);
        }
      });
    },

    // 下载文件
    download (data) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let alink = document.createElement("a");
      alink.href = url;
      let date = new Date();
      let time =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      alink.download =
        this.activeTab == 1
          ? time + "手术项目费用组成单.xls"
          : time + "非手术项目费用组成单.xls"; //文件名

      alink.click();
      this.export_loading = false;
    },

    //获取项目列表  手术
    getProjectList1 () {
      this.$db
        .post(this.$db.config.cf_project.info.simple, { project_type: 1 })
        .then((res) => {
          this.$set(this, "projectList1", res.data);
        });
    },

    //获取项目列表 非手术
    getProjectList2 () {
      this.projectList2 = [];
      this.$db
        .post(this.$db.config.cf_project.info.simple, { project_type: 2 })
        .then((res) => {
          this.$set(this, "projectList2", res.data);
        });
    },

    //查看拨款详情
    goDetail (row, type) {
      if (type == 1) {
        this.project_id = row.project_id;
        this.pay_id = row.pay_id;
      } else {
        this.project_id = row.id;
        this.pay_id = row.apply_pay_id;
      }

      this.detail_title.pro_name = row.project_name;
      this.detail_title.user_name = row.user_name;
      this.project_type = type;
      this.if_open4 = true;
    },

    //查看手术项目详情
    goDetail1 (row) {
      this.project_apply_id = row.project_apply_id;
      this.project_id = row.project_id;
      this.if_open = true;
    },

    //查看非手术项目详情
    goDetail2 (row) {
      this.project_id = row.id;
      this.if_open = true;
    },

    //查看申请人详情
    goDetail3 (row) {
      this.project_id = row.project_id;
      this.apply_id = row.id;
      this.if_open3 = true;
    },

    //手术项目拨款申请操作
    doPayment1 (row) {
      this.project_id = row.project_id;
      this.project_apply_id = row.project_apply_id;
      this.apply_id = row.id;
      this.pay_id = row.pay_id;
      this.info_title1.pro_name = row.project_name;
      this.info_title1.user_name = row.user_name;
      this.if_open1 = true;
    },

    //非手术项目拨款申请操作
    doPayment2 (row = false) {
      // this.project_id = row.id;

      // this.project_apply_id = row.project_apply_id;
      // this.money = row.top_money;
      // this.info_title2 = row.project_name;
      this.apply_id = row ? row.apply_pay_id : null;
      this.if_open2 = true;
    },

    //拨款申请回调
    success (val) {
      this.activeTab = val;
      if (val == 1) {
        this.$refs["tables1"].reloadData();
      } else {
        this.$refs["tables2"].reloadData();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      min-height: 606px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/appropriation/list.vue